import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic";

import { UnderlineColorKeyToClassName } from "../../helpers/datasourceHelpers";
import { useStoryblokGlobalSettings } from "../../hooks/useStoryblokGlobalSettings";

import styles from "./listingHeader.module.scss";

function ListingHeader({ children, underlineColor, withClass }) {
  return (
    <div
      className={`${styles.listingheader} ${withClass} ${UnderlineColorKeyToClassName(
        underlineColor
      )}`}
    >
      <div>{children}</div>
    </div>
  );
}

function ListingHeaderWithYuzu({ children, underlineColor }) {
  const globalSettings = useStoryblokGlobalSettings()

  return (
    <div className={styles.listingheaderwithyuzu}>
      <div className={styles.content}>
        {children}
      </div>
      {globalSettings && globalSettings.yuzu_headline_image && globalSettings.yuzu_headline_image.filename ? <StoryblokImageBasic image={globalSettings.yuzu_headline_image} /> : null}
      <div className={`${styles.yuzuUnderline} ${UnderlineColorKeyToClassName(underlineColor)}`} />
    </div>
  );
}

export default ListingHeader;
export {
  ListingHeaderWithYuzu
}
